import { useTranslation } from 'react-i18next';

import { type ActiveBannerMessage, useOutageBanner } from './useOutageBanner';
import WarningBanner from './components/WarningBanner';
import ActiveOutageBanner from './components/ActiveOutageBanner';

type BannerConfig = {
  shouldRender: boolean,
  render: (message: ActiveBannerMessage) => JSX.Element
};

const OutageBanner = () => {
  const { t } = useTranslation();
  const { activeMessage, dismissWarning, lastUpdated } = useOutageBanner();
  const bannerConfigs: BannerConfig[] = [
    {
      shouldRender: activeMessage?.type === 'outage',
      render: (message) => (
        <ActiveOutageBanner
          title={t('OUTAGE.TITLE.ACTIVE')}
          message={message}
          lastUpdated={lastUpdated}
        />
      )
    },
    {
      shouldRender: activeMessage?.type === 'warning',
      render: (message) => (
        <WarningBanner
          title={t('OUTAGE.TITLE.WARNING')}
          message={message}
          onDismiss={dismissWarning}
        />
      )
    },
  ];

  return bannerConfigs
    .find((config) => config.shouldRender)
    ?.render(activeMessage as ActiveBannerMessage) ?? null;
};

export default OutageBanner;
